import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class PlayIntroAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        await this.emitter.emitAsync('General.Game.PLAY_INTRO');
    }

    getName(): string {
        return 'PlayIntroAct';
    }
}